import s from '../../Outside/pages/style/chat.module.scss';
import { inject, observer } from 'mobx-react';
import tipCloseImg from '@/assets/images/mobile/tip_close.png';
import { Mask } from 'antd-mobile';
import hiImg from '@/assets/images/hi.png';
import { Display } from '@/components/Display/Display';
const AgentInfo = (props) => {
    const { grtAi, chatStore, skillStore } = props.store;
    const { curSkill } = skillStore;
    const { currentAgent = {} } = grtAi.state;
    let { showAgentModal, setShowAgentModal } = chatStore;
    const openAgentModal = () => {
        setShowAgentModal(true);
    };
    const closeAgentModal = () => {
        setShowAgentModal(false);
    };
    return (
        <>
            <div className={s['no-content']} onClick={openAgentModal}>
                <Display show={curSkill?.ability_id != -1}>
                    <div className={s['introduce']}>{curSkill?.show_description || `Hi~，我是${curSkill?.show_name}`}</div>
                </Display>
                <Display show={curSkill?.ability_id == -1}>
                    <div className={s['introduce']}>{currentAgent?.introduction || `Hi~，我是${currentAgent?.name}`}</div>
                </Display>
                <img className={[s['agent-img']]} src={currentAgent?.agent_figure} alt="" />
            </div>

            <Mask visible={showAgentModal}>
                <div className={s['agent-info-mask']}>
                    <div className={s['agent-info-wrap']}>
                        <img className={s['hi-img']} src={hiImg} alt="" />
                        <img className={s['agent-icon']} src={currentAgent?.agent_icon} alt="" />
                        <div className={s['agent-title']}>我是{currentAgent?.name}，看看我能做些什么吧</div>

                        <div className={s['agent-info']} data-empty={!currentAgent?.description}>
                            {currentAgent?.description || '还没来得及写简介，直接和我开始对话吧～'}
                        </div>

                        <img className={s['close']} onClick={closeAgentModal} src={tipCloseImg} alt="" />
                    </div>
                </div>
            </Mask>
        </>
    );
};

export default inject('store')(observer(AgentInfo));
